import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    selectInput: {
      "& input": {
        padding: theme.spacing(3, 0, 3, 7),
      },
    },
    description: {
      fontSize: 14,
      color: theme.gray500,
      margin: theme.spacing(2, 0, 10),
    },
  }),
);
